import React from 'react';
import { ChevronLeft } from 'lucide-react';

interface AppleHeaderProps {
  title: string;
  onBack?: () => void;
  backLabel?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
}

const AppleHeader: React.FC<AppleHeaderProps> = ({
  title,
  onBack,
  backLabel = 'Atrás',
  actionLabel,
  onAction,
  actionDisabled = false,
}) => {
  const backButton = onBack ? (
    <button
      type="button"
      onClick={onBack}
      className="inline-flex items-center gap-1 text-[#1644EB] active:opacity-50 sm:active:opacity-100 sm:hover:opacity-70 transition-opacity text-[15px] font-normal"
    >
      <ChevronLeft className="w-5 h-5" />
      <span>{backLabel}</span>
    </button>
  ) : (
    <div className="w-16" aria-hidden="true" />
  );

  const actionButton = actionLabel && onAction ? (
    <button
      type="button"
      onClick={onAction}
      disabled={actionDisabled}
      className={`text-[15px] font-semibold active:opacity-50 sm:active:opacity-100 transition-opacity ${
        actionDisabled ? 'text-black/20 cursor-not-allowed' : 'text-[#1644EB] sm:hover:opacity-70'
      }`}
    >
      {actionLabel}
    </button>
  ) : (
    <div className="w-16" aria-hidden="true" />
  );

  return (
    <>
      {/* Mobile header */}
      <div className="sm:hidden mt-2 mb-4 flex items-center justify-between h-10">
        {backButton}
        <h1 className="absolute left-1/2 -translate-x-1/2 text-[15px] font-semibold text-black/90">{title}</h1>
        {actionButton}
      </div>

      {/* Desktop header */}
      <div className="hidden sm:flex items-center justify-between mb-6 h-11">
        {backButton}
        <h1 className="absolute left-1/2 -translate-x-1/2 text-[17px] font-semibold text-black/90">{title}</h1>
        {actionButton}
      </div>
    </>
  );
};

export default AppleHeader;
